import React, { forwardRef } from 'react';

import { PureErrorBoundary } from '@bringg/react-components';
import { errorNotifier } from '@bringg-frontend/bringg-web-infra';

import WorkflowCard from '../workflow-card/workflow-card';
import RenderErrorFallback from '../workflow-card/components/render-error-fallback';
import UnreadableWorkflowCard from '../unreadable-workflow-card/unreadable-workflow-card';
import { isUnreadableWorkflow, WorkflowRepoItem } from '../../stores/unreadable-workflow';

interface Props {
	expanded?: boolean;
	viewMode?: boolean;
	shouldScrollToView?: boolean;
	workflow: WorkflowRepoItem;
}

const WorkflowRepoItemCard = forwardRef<HTMLDivElement, Props>(function WorkflowRepoItemCard(
	{ workflow, expanded, viewMode, shouldScrollToView }: Props,
	ref
) {
	if (isUnreadableWorkflow(workflow)) {
		return (
			<PureErrorBoundary
				onError={errorNotifier}
				fallback={() => <RenderErrorFallback id={workflow.id} title={workflow.title} />}
			>
				<UnreadableWorkflowCard ref={ref} workflow={workflow} shouldScrollToView={shouldScrollToView} />
			</PureErrorBoundary>
		);
	}

	return (
		<WorkflowCard
			ref={ref}
			workflow={workflow}
			expanded={expanded}
			viewMode={viewMode}
			shouldScrollToView={shouldScrollToView}
		/>
	);
});

export default WorkflowRepoItemCard;
